import type { ReactElement } from 'react';
import { Check } from 'lucide-react';
import { CategoryBadge } from './CategoryBadge';
import { ProcessNameWithStatus } from './ProcessNameWithStatus';

interface ToolNameFilterOptionProps {
  name: string;
  isSelected: boolean;
}

export function ToolNameFilterOption({
  name,
  isSelected,
}: ToolNameFilterOptionProps): ReactElement {
  return (
    <div className="flex items-center gap-3 flex-1 px-0.5 py-0.5">
      <div className="flex items-center justify-center w-4 h-4 shrink-0">
        {isSelected && (
          <Check className="size-4 text-primary" strokeWidth={2.5} />
        )}
      </div>
      <ProcessNameWithStatus name={name} />
    </div>
  );
}

interface CategoryFilterOptionProps {
  category: string;
  isSelected: boolean;
}

export function CategoryFilterOption({
  category,
  isSelected,
}: CategoryFilterOptionProps): ReactElement {
  return (
    <div className="flex items-center gap-3 flex-1 px-0.5 py-0.5">
      <div className="flex items-center justify-center w-4 h-4 shrink-0">
        {isSelected && (
          <Check className="size-4 text-primary" strokeWidth={2.5} />
        )}
      </div>
      <CategoryBadge category={category} />
    </div>
  );
}

export { CategoryFilterOption as RunningNowCategoryFilterOption };
